// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import {useEffect, useMemo, useState} from 'react';

export const get_width = ()=>window.visualViewport?.width
    || window.innerWidth
    || document.documentElement && document.documentElement.clientWidth
    || document.body && document.body.clientWidth;
export const get_height = ()=>window.visualViewport?.height
    || window.innerHeight
    || document.documentElement && document.documentElement.clientHeight
    || document.body && document.body.clientHeight;

export type t_screen = 'xs'|'sm'|'md'|'lg'|'xl';
interface i_use_screen_ret {
    inner_width: number;
    width: number;
    height: number;
    screen: t_screen;
    is_touch?: boolean;
    is_client?: boolean;
}
let global_hooks:(p:i_use_screen_ret)=>i_use_screen_ret = p=>p;
export const use_screen_hook = (hook:(p:i_use_screen_ret)=>i_use_screen_ret)=>{
    global_hooks = hook;
};
export const use_screen = ()=>{
    const [inner_width, set_inner_width] = useState(window?.innerWidth);
    const [width, set_width] = useState(get_width());
    const [height, set_height] = useState(get_height());
    const [is_client, set_is_client] = useState(false);
    const [is_touch, set_is_touch] = useState<i_use_screen_ret['is_touch']>();
    useEffect(()=>{
        const handle_resize = ()=>{
            set_inner_width(window.innerWidth);
            set_width(get_width());
            set_height(get_height());
        };
        window.addEventListener('resize', handle_resize);
        set_is_touch('ontouchstart' in window || navigator.maxTouchPoints > 0);
        set_is_client(true);
        if (window.visualViewport)
            window.visualViewport.addEventListener('resize', handle_resize);
        return ()=>{
            window.removeEventListener('resize', handle_resize);
            if (window.visualViewport)
            {
                window.visualViewport.removeEventListener('resize',
                    handle_resize);
            }
        };
    }, []);
    const screen = width >= 1200 ? 'xl' : width >= 992 ? 'lg'
        : width >= 768 ? 'md' : width >= 640 ? 'sm' : 'xs';
    return global_hooks({inner_width, width, height, screen, is_touch,
        is_client});
};

type t_size = number[];
export type t_element_size = t_size | {
    all: t_size;
    xs?: t_size;
    sm?: t_size;
    md?: t_size;
    lg?: t_size;
    xl?: t_size;
};
export const use_element_size = (size?: t_element_size)=>{
    const {screen} = use_screen();
    const [w, h] = useMemo(()=>{
        if (!size)
            return [];
        const s = Array.isArray(size) ? size : size[screen]||size.all;
        return [`${s[0]}px`, `${s[1]}px`];
    }, [screen, size]);
    return [w, h];
};
